import React, {useEffect, useState} from 'react';
import {Divider, Grid} from '@material-ui/core/';
import {PlayArrow} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Form from 'components/Form/FormTwoColumns';

function DatosDiscapacidades(props) {   
    const classes = useStyles()
    const [elements, setElements] = useState({     
        showList: { idelement: "showList", icon: <PlayArrow />,  data: [], elementType:'list', value: "",}, 
    });

    const funcionAsignarDiscapacidadesAsignadas = () =>{
        let newElements= Object. assign({}, elements);
        let dispacidadesEntrantes = []
        let getDiscapacidades = props.datosCiudadanoTable.subDiscapacidadesCiudadano
        newElements.showList.data = []
        for (let index = 0; index < getDiscapacidades.length; index++) {
            dispacidadesEntrantes.push({
                title: getDiscapacidades[index].catalogoDiscapacidad?.categoria +' - '+getDiscapacidades[index].subcategoria+': ',
                description: getDiscapacidades[index].descripcion,                
            })
        }
        newElements.showList.data = dispacidadesEntrantes
        setElements(newElements);
    }

    useEffect(()=>{
        funcionAsignarDiscapacidadesAsignadas();
    },[])
    
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>Discapacidades asignadas</strong> <Divider /></div>
            </Grid >                            
            <Grid item xs={12}>
                <Form elements={elements}/>
            </Grid >
        </Grid>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(DatosDiscapacidades);